import {
  PLAYER_LIVE_OPTIONS_SHOW_OPTIONS,
  PLAYER_LIVE_OPTIONS_HIDE_OPTIONS,
} from '../../actions/optionButtons/constants';

const initialState = {
  isOpen: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case PLAYER_LIVE_OPTIONS_SHOW_OPTIONS:
      return { isOpen: true };
    case PLAYER_LIVE_OPTIONS_HIDE_OPTIONS:
      return { isOpen: false };
    default:
      return state;
  }
};
